import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { faqs } from '../data/faqs';
import { business } from '../data/business';
import { ui } from '../data/translations';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-mist py-20 lg:py-28" data-id="element-57" data-mp="2dzoeffdinqsa">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[4fr_8fr] lg:gap-16 lg:px-8" data-id="element-58" data-mp="2913dfdqfx32s">
        <div data-id="element-59" data-mp="241gx2vfbf6pr">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy lg:text-4xl" data-id="element-60" data-mp="240ytfdqbpq7t">{t(ui.faq.title)}</h2>
          <p className="mt-4 text-steel" data-id="element-61" data-mp="1z2xd30ka8501">{t(ui.faq.subtitle)}</p>
          <div className="mt-10 border-t border-black/10 pt-8" data-id="element-62" data-mp="snd49skgroma">
            <p className="font-display font-semibold text-navy" data-id="element-63" data-mp="no0asoz37jaq">{t(ui.faq.stillQuestions)}</p>
            <p className="mt-1 text-sm text-steel" data-id="element-64" data-mp="nqcxfffsihu4">{t(ui.faq.callUs)}</p>
            <a href={business.phoneHref} className="mt-4 inline-flex items-center gap-2 font-display text-lg font-bold text-navy hover:text-gold-dark" data-id="element-65" data-mp="pipl7xkwqb4c">
              <PhoneIcon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-66" data-mp="fj8ldwsc6rga" />
              {business.phoneDisplay}
            </a>
          </div>
        </div>

        <ul className="space-y-3" data-id="element-67" data-mp="6r6jrv6j754f">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <li key={faq.question.en} className={`rounded-md border-l-4 bg-white transition-colors duration-150 ${open ? 'border-gold' : 'border-gold/30'}`} data-id="element-68" data-mp="3t07v0ak8ps7e" data-mpi={i}>
                <h3 data-id="element-69" data-mp="3nzk0vg0psv8y">
                  <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-display text-base font-semibold text-navy transition-colors duration-150 hover:bg-mist/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-70" data-mp="3nztiogblvw3k">
                    {t(faq.question)}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-steel transition-transform duration-200 ease-snappy ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-71" data-mp="28g42guwqz3u0" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-72" data-mp="s2dxzn1pudju">
                  {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-73" data-mp="s09lwhtny88h">
                      <p className="px-5 pb-5 text-steel" data-id="element-74" data-mp="3dgtv8oqyu1zq">{t(faq.answer)}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}